var render = function render(){var _vm=this,_c=_vm._self._c;return _c('path',{staticClass:"cls-1",attrs:{"d":"M392.671,567.668L385,566l7.671-3.668A13.019,13.019,0,0,1,393,565a14.659,14.659,0,0,1-.333,2.668h0Zm-0.667,1.5A9.909,9.909,0,0,1,383,575,10,10,0,0,1,383,555v11.671Zm0-8.5L384,565V555a11.038,11.038,0,0,1,8,5.665h0Zm0,0","transform":"translate(-373 -555)"}})
}
var staticRenderFns = []

export { render, staticRenderFns }